import excelUrl from '../../../static/image/excel-placeholder.png'
import wordUrl from '../../../static/image/word-placeholder.png'
import rarUrl from '../../../static/image/rar-placeholder.png'
import ziplUrl from '../../../static/image/zip-placeholder.png'
import { computed } from 'vue'
import { ifExcel, ifRar, ifZip, ifWord } from '../util/file-util'
export function useOther({ attach }) {
  const otherAttach = computed(() => {
    // excel
    if (ifExcel(attach.value)) return excelUrl
    // rar
    if (ifRar(attach.value)) return rarUrl
    // zip
    if (ifZip(attach.value)) return ziplUrl
    // word
    if (ifWord(attach.value)) return wordUrl
    return ''
  })

  return {
    otherAttach,
  }
}
